'use client'
import React, { createContext, useContext, useRef } from 'react'
interface Props {
  toggle: () => void
}
interface SidebarProviderProps {
  children?: React.ReactNode
}
const SidebarContext = createContext({} as Props)

const SidebarProvider = ({ children }: SidebarProviderProps) => {
  const isOpen = useRef(false)

  const toggle = () => {
    const sidebarDiv = document.getElementById('sidebar')
    sidebarDiv?.classList.toggle('sidebar-full')
    const bodyWrapper = document.getElementById('body-wrapper')
    bodyWrapper?.classList.toggle('body-wrapper')
    if (!isOpen.current) {
      document.addEventListener('click', handleClickOutside)
    } else document.removeEventListener('click', handleClickOutside)
    isOpen.current = !isOpen.current
  }

  const handleClickOutside = (event: MouseEvent) => {
    const sidebarDiv = document.getElementById('sidebar')
    if (event.target && !sidebarDiv?.contains(event.target as Node)) {
      toggle()
    }
  }

  return (
    <SidebarContext.Provider value={{ toggle }}>
      {children}
    </SidebarContext.Provider>
  )
}

export default SidebarProvider
export const useSidebarContext = () => useContext(SidebarContext)
